// @ts-strict-ignore
import * as React from 'react';

import Radio from 'components/Radio';
import { Text } from 'components/typography';
import { Language } from 'components/video-player';
import { SubtitlesContext } from './contexts';

type SubtitlesItemProps = React.AllHTMLAttributes<HTMLElement> & {
  language: Language;
};

const SubtitlesItem = ({ language: l, className }: SubtitlesItemProps) => {
  const { subtitle, handleSubtitle, previouslySelectedSubtitle } =
    React.useContext(SubtitlesContext);

  const subtitleLabel = React.useMemo(() => {
    return (
      <div
        className="w-100 flex flex-row whitespace-nowrap"
        data-testid="subtitles-item-label"
      >
        <Text
          size="m"
          data-testid="subtitles-item-endonym"
          className={
            subtitle === l.languageCode ||
            previouslySelectedSubtitle === l.languageCode
              ? 'font-bold'
              : ''
          }
        >
          {l.endonym}
        </Text>
        <Text
          size="m"
          className="ml-1 flex text-gray-500 opacity-70"
          data-testid="subtitles-item-name"
        >
          {l.languageName}
        </Text>
      </div>
    );
  }, [l, previouslySelectedSubtitle, subtitle]);

  return (
    <div className={className} data-testid="subtitles-item">
      <Radio
        data-testid="subtitles-item-radio"
        checked={
          subtitle === l.languageCode ||
          previouslySelectedSubtitle === l.languageCode
        }
        label={subtitleLabel}
        name="subtitle-language"
        onChange={() => {
          handleSubtitle(l.languageCode);
        }}
        value={l.languageCode}
      />
    </div>
  );
};

export default SubtitlesItem;
